var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "900" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("visibility")]),
              _vm._v(" Documento adjunto\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", icon: "", title: "Ver en otra ventana" },
                  on: {
                    click: function($event) {
                      return _vm.openNewWindow()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("fullscreen")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                [
                  _c("v-flex", [
                    _vm.tipo_documento === "pdf"
                      ? _c("embed", {
                          attrs: {
                            src:
                              _vm.api_backend[0] + _vm.documento.ruta_archivo,
                            type: "application/pdf",
                            width: "100%",
                            height: "700px"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tipo_documento === "jpg" ||
                    _vm.tipo_documento === "png" ||
                    _vm.tipo_documento === "jpeg"
                      ? _c("img", {
                          attrs: {
                            src:
                              _vm.api_backend[0] + _vm.documento.ruta_archivo,
                            width: "100%"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tipo_documento === "docx" ||
                    _vm.tipo_documento === "doc"
                      ? _c("embed", {
                          attrs: {
                            src:
                              _vm.api_backend[0] + _vm.documento.ruta_archivo,
                            type: "application/pdf",
                            width: "100%",
                            height: "700px"
                          }
                        })
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9d7ed42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9d7ed42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/VerDocumento.vue
// module id = null
// module chunks = 